export const headerHeight = 64;

export const footerHeight = 64;

export const playerControllerHeight = 74;

export const contentPlaceholderHeight = 64;
